import React from 'react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    console.error('Error caught by boundary:', error, errorInfo);
    // 通知父组件有错误发生
    if (this.props.onError) {
      this.props.onError();
    }
  }

  render() {
    if (this.state.hasError) {
      // 如果有 fallback 组件，使用它
      if (this.props.fallback) {
        return this.props.fallback;
      }

      // 默认的错误显示
      return (
        <div className="text-gray-700 leading-relaxed whitespace-pre-wrap">
          {this.props.children}
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
